import '../SquareTile.css';
import {SquareTileTitle} from "../../../../model/models";

interface SquareTileBadgeProps {
    count?: number;
    title?: string;
}

export function SquareTileBadge({ count, title }: SquareTileBadgeProps) {
    if (title !== SquareTileTitle.ATTIVITA || !count || count <= 0) return null;

    return <div className="square-tile-badge">{count}</div>;
}